import React from 'react'
import classnames from 'classnames'

import RichText from '../RichText/RichText'
import Button from '../Button/Button'

import { container, logos, ands } from './Partner.module.scss'

const Partner = ({ logo1, logo2, text, link, className }) => {
  return (
    <div className={classnames(container, className)}>
      <div className={logos}>
        <img
          src={logo1.sourceUrl}
          alt={logo1.altText}
          width={logo1.mediaDetails.width}
          height={logo1.mediaDetails.height}
        />
        <div className={ands}>&</div>
        <img
          src={logo2.sourceUrl}
          alt={logo2.altText}
          width={logo2.mediaDetails.width}
          height={logo2.mediaDetails.height}
        />
      </div>
      <div>
        <RichText>{text}</RichText>
        {link && (
          <Button href={link.url} target={'_blank'} rel={'noreferrer'} hollow>
            {link.title}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Partner
